exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-top-selling {\n  position: absolute;\n  float: right !important;\n  right: 0;\n  width: 95%;\n}\n.fixed-top-downpayment {\n  position: fixed;\n  float: right !important;\n  top: 48%;\n  /* right: 0; */\n  /* left: 0; */\n  width: 37%;\n}\n.mt-4-5 {\n  margin-top: 2rem !important;\n}\n.bubble-info {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eb82bd8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard/Pages/Orders/Form.vue
// module id = aq97
// module chunks = 4